import _ from "underscore";
// organizeSocial

export const organizeSocial = (params) => {
	const { facebook, twitter } = params;

	if (facebook && twitter) {
		const unsortedFeed = [...facebook, ...twitter];
		return _.sortBy(unsortedFeed, "date").reverse();
	} else {
		return facebook || twitter;
	}
};

export const faker = (params) => {};
